import Vue from 'vue'
import router from '@/router'
import Router from 'vue-router'

Vue.router = router
Vue.use(Router)
